import React from 'react';
import { Box } from '@mui/material';
import { APP_NAME, LOGO_PATH } from '../../constants/brand';

/** Auth / login page logo size */
export const BRAND_LOGO_AUTH_HEIGHT = 43;
export const BRAND_LOGO_MAX_HEIGHT = 43;
export const BRAND_LOGO_AUTH_MAX_WIDTH = 180;

interface BrandLogoProps {
  height?: number;
  alt?: string;
  fullWidth?: boolean;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  height = BRAND_LOGO_AUTH_HEIGHT,
  alt = APP_NAME,
  fullWidth = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: fullWidth ? '100%' : 'auto',
    }}
  >
    <Box
      component="img"
      src={LOGO_PATH}
      alt={alt}
      sx={{
        height: 'auto',
        maxHeight: `${height}px`,
        width: 'auto',
        maxWidth: fullWidth ? '100%' : BRAND_LOGO_AUTH_MAX_WIDTH,
        objectFit: 'contain',
        display: 'block',
      }}
    />
  </Box>
);
